import interceptor from 'rest/interceptor';
import AdminConstants from '../../../constants/AdminConstants';

export default interceptor({
  request(request) {
    const headers = request.headers;
    const token = localStorage.getItem(AdminConstants.token_key);

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    return request;
  },
});
